import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { IndentWidthType } from '../index';

export interface DocsPageContentSpaceProps
{
    withSpace?: IndentWidthType,
}

const DocsPageContentSpace: FunctionComponent<DocsPageContentSpaceProps> = ({ withSpace = IndentWidthType.NONE, ...rest }) =>
{
    return <DocsPageContentSpaceWrapper withSpace={withSpace} {...rest}/>;
};

export default DocsPageContentSpace;

const DocsPageContentSpaceWrapper = styled.div<{ withSpace: IndentWidthType }>`
  display: block;
  margin-bottom: ${props => props.withSpace === IndentWidthType.NONE && '0px'};
  margin-bottom: ${props => props.withSpace === IndentWidthType.NONE && '5px'};
  margin-bottom: ${props => props.withSpace === IndentWidthType.XSMALL && '20px'};
  margin-bottom: ${props => props.withSpace === IndentWidthType.SMALL && '40px'};
  margin-bottom: ${props => props.withSpace === IndentWidthType.MEDIUM && '50px'};
  margin-bottom: ${props => props.withSpace === IndentWidthType.LARGE && '60px'};
`;
